import * as entity from '@common/domain/entities/JobCard'
import { IDataEndPoint, IEntityEndPoints } from '../../../framework/interfaces/IEntity';
import { IApiServiceCommand } from '../../../services/api/api.service';
import * as app from '@framework/app';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
export class JobCardEndPoints extends entity.JobCardEndPoints {
  insert?: IDataEndPoint =
    {
      url: function (serviceCommand: IApiServiceCommand): string {
        debugger;
        return app.config.controllerRouteRoot + "/jobCard/createJobCard/" + serviceCommand.context.parent.previousEntityId
      }, method: "POST"
    };
}
export class JobCardEndPointsEstimate implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/WorkOrder/jobCard/" + serviceCommand.context.entityId + '/1'
    }
  }
}
export class JobCardEndPointsJobcards implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/WorkOrder/jobCard/" + serviceCommand.context.entityId + '/1'
    }
  }

}
export class JobCardEndPointsActual implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/WorkOrder/jobCard/" + serviceCommand.context.entityId + '/2'
    }
  }
}
export class JobCardEndPointsInvoice implements IEntityEndPoints {
  list?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/WorkOrder/jobCard/" + serviceCommand.context.entityId + '/3'
    }
  }
}

export class JobCardFormEndPoints implements IEntityEndPoints {
  get?: IDataEndPoint = {
    url: function (serviceCommand: IApiServiceCommand): string {
      return app.config.controllerRouteRoot + "/jobCard/" + serviceCommand.context.entityId
    }
  }
}

export class JobCardFormFields extends entity.JobCardFormFields {
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
    } catch  { }
    this.splice(0,this.length)
    var idCol = FormBuilderControlListHelper.getListColumn("id", "id");
    idCol.visible = false;
    this.push(idCol);
    this.push(FormBuilderControlListHelper.getListColumn("workflowStatusId", "Workflow Status", null, null, "workflowStatusId"));
    this.push(FormBuilderControlListHelper.getListColumn("jobCardNo", "J/C No", null, null, "jobCardNo"));
  }
}

export class JobCardForm extends entity.JobCardForm {
  protected jobCardFormEndPoints: JobCardEndPoints = new JobCardEndPoints();
  protected jobCardFormFields: JobCardFormFields = new JobCardFormFields();
}

export class JobCardListColumns extends entity.JobCardListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      
    } catch  { }
    this.splice(0, this.length);
    this.push(this.id)
    this.id.visible = false;
    this.push(this.workflowStatusId);
    this.push(this.jobCardNo);
    //this.push(FormBuilderControlListHelper.getListColumn("workflowStatusId", "Workflow Status", null, null, "workflowStatusId"));
    //this.push(FormBuilderControlListHelper.getListColumn("jobCardNo", "J/C No", null, null, "jobCardNo"));
  }
}

export class JobCardList extends entity.JobCardList {
  protected jobCardListEndPoints: JobCardEndPoints = new JobCardEndPoints();
  protected jobCardListColumns: JobCardListColumns = new JobCardListColumns();
}
export class JobCardListEstimate extends JobCardList {
  protected jobCardListEndPoints: JobCardEndPoints = new JobCardEndPointsEstimate();
}
export class JobCardListActual extends JobCardList {
  protected jobCardListEndPoints: JobCardEndPoints = new JobCardEndPointsActual();
}
export class JobCardListInvoice extends JobCardList {
  protected jobCardListEndPoints: JobCardEndPoints = new JobCardEndPointsInvoice();
}
export class JobCardListJobCards extends JobCardList {
  protected jobCardListEndPoints: JobCardEndPoints = new JobCardEndPointsJobcards();
}

